import { IconProps } from '@bechtel/gds';
import { HTMLAttributes } from 'react';

export interface MultiStatBlockComponentProps {
  value: string;
  valueText: string;
  total: string;
  totalText: string;
  icon: IconProps['icon'];
  loading?: boolean;
}

export type MultiStatBlockProps = MultiStatBlockComponentProps & HTMLAttributes<HTMLDivElement>;
